import type { TabOwnProps as MuiTabOwnProps } from '@mui/material/Tab';

import TabsContext from './TabsContext';
import TabsPanel from './TabsPanel';
import TabsList from './TabsList';
import Tab from './Tab';

export interface TabsProps {
  children: JSX.Element | JSX.Element[];
}

export interface TabsWrapperProps {
  initialValue: MuiTabOwnProps['value'];
  children: JSX.Element | JSX.Element[];
  queryParamKey?: string;
  /**
   * The values this strip has — see `TabsContext`. Vets `?<queryParamKey>=`.
   * Strings only, and that is load-bearing: see the prop's doc there.
   */
  allowedValues?: string[];
}

const Tabs = ({
  allowedValues,
  children,
  initialValue,
  queryParamKey,
}: TabsWrapperProps) => {
  return (
    <TabsContext
      allowedValues={allowedValues}
      queryParamKey={queryParamKey}
      initialValue={initialValue}
    >
      {children}
    </TabsContext>
  );
};

Tabs.Tab = Tab;
Tabs.TabPanel = TabsPanel;
Tabs.TabsList = TabsList;

export default Tabs;
